/*!

=========================================================
* Paper Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useEffect, useState} from "react";
import { connect } from 'react-redux';
import {getCurrentUser} from 'actions/userActions';
import classnames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
} from "reactstrap";

function AdminNavbar(props) {
  const { handleMiniClick, getCurrentUser, currentUser, loadingUser} = props;
  const navigate = useNavigate();
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [color, setColor] = useState("navbar-transparent");
  const location = useLocation();
  useEffect(() => {
    getCurrentUser()
    window.addEventListener("resize", updateColor);
  },[]);
  useEffect(() => {
    if (
      window.outerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }, [location]);


  const [noCompany, setNoCompany] = useState(false);
  useEffect(() => {
    if (!loadingUser&&currentUser!==null){
      setNoCompany(currentUser.company==null)
    }
  }, [loadingUser]) 

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
  };
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setSidebarOpen(!sidebarOpen);
  };
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  const toggleCollapse = () => {
    if (!collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
    setCollapseOpen(!collapseOpen);
  };
  return( <>
    {noCompany&&<span  className='no-company-warning' onClick={()=>{navigate('/admin/profile')}}>
      By w pełni wykorzystać możliwości strony, musisz dołączyć do firmy! Kliknij tutaj, by uzupełnić profil
    </span>}
  </>)
  // return (
  //   <>
  //     <Navbar
  //       className={classnames("navbar-absolute fixed-top", color)}
  //       expand="lg"
  //     >
  //       <Container fluid style={{marginLeft: '20px'}}>
  //         <div className="navbar-wrapper">
  //           <div className="navbar-minimize">
  //             <Button
  //               className="btn-icon btn-round"
  //               color="default"
  //               id="minimizeSidebar"
  //               onClick={handleMiniClick}
  //             >
  //               <i className="nc-icon nc-minimal-right text-center visible-on-sidebar-mini" />
  //               <i className="nc-icon nc-minimal-left text-center visible-on-sidebar-regular" />
  //             </Button>
  //           </div>
  //           <div
  //             className={classnames("navbar-toggle", {
  //               toggled: sidebarOpen,
  //             })}
  //           >
  //             <button
  //               className="navbar-toggler"
  //               type="button"
  //               onClick={toggleSidebar}
  //             >
  //               <span className="navbar-toggler-bar bar1" />
  //               <span className="navbar-toggler-bar bar2" />
  //               <span className="navbar-toggler-bar bar3" />
  //             </button>
  //           </div>
  //           <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
  //             <span className="d-none d-md-block">
  //               App Standard Rachunku Kosztów
                
  //             </span>
  //             <span className="d-block d-md-none">App SRK</span>
  //           </NavbarBrand>
  //         </div>
  //         <button
  //           aria-controls="navigation-index"
  //           aria-expanded={collapseOpen}
  //           aria-label="Toggle navigation"
  //           className="navbar-toggler"
  //           // data-target="#navigation"
  //           data-toggle="collapse"
  //           type="button"
  //           onClick={toggleCollapse}
  //         >
  //           <span className="navbar-toggler-bar navbar-kebab" />
  //           <span className="navbar-toggler-bar navbar-kebab" />
  //           <span className="navbar-toggler-bar navbar-kebab" />
  //         </button>
  //         <Collapse
  //           className="justify-content-end"
  //           navbar
  //           isOpen={collapseOpen}
  //         >
  //           <Nav navbar>
  //           </Nav>
  //         </Collapse>
  //       </Container>
        
  //       {noCompany&&<span  className='no-company-warning' onClick={()=>{navigate('/admin/profile')}}>
  //                 By w pełni wykorzystać możliwości strony, musisz dołączyć do firmy! Kliknij tutaj, by uzupełnić profil
  //               </span>}
  //     </Navbar>
  //   </>
  // );
}

const mapStateToProps = (state) => ({
  currentUser: state.UserReducer.currentUser,
  loadingUser: state.UserReducer.loadingUser,
});

export default connect(mapStateToProps, { getCurrentUser })(AdminNavbar)
